/**
 * side-drawer.tsx — Ngăn kéo trượt NGANG từ cạnh trái (kiểu bộ lọc của Lark Mobile): cao toàn màn hình, rộng ~85% (tối đa 24rem),
 * phần còn lại là lớp phủ mờ — chạm để đóng. Chừa vùng an toàn trên / dưới. Dựng trên Radix Dialog (khoá cuộn nền, Esc, bẫy focus).
 */
import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@/lib/utils'

export const SideDrawer = DialogPrimitive.Root
export const SideDrawerClose = DialogPrimitive.Close

export const SideDrawerContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { title: string }
>(({ className, children, title, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/45 animate-fade-in" />
    <DialogPrimitive.Content
      ref={ref}
      aria-describedby={undefined}
      onOpenAutoFocus={(e) => e.preventDefault()}
      className={cn(
        'fixed inset-y-0 left-0 z-50 flex h-dvh w-[85vw] max-w-sm flex-col bg-background shadow-2xl outline-none',
        'pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] pt-[env(safe-area-inset-top)] animate-drawer-left',
        className,
      )}
      {...props}
    >
      <DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
))
SideDrawerContent.displayName = 'SideDrawerContent'
